/* eslint-disable */
import * as Types from '../../../../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActionsQueryQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ActionsQueryQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    username: string;
    permissions: Array<Types.RbacPermissionType>;
    team?: {
      __typename?: 'Team';
      id: string;
      name?: string | null;
      ssoState: Types.TeamSsoState;
    } | null;
    teamMembership?: {
      __typename?: 'UserTeamMembership';
      id: string;
      isEnterprise: boolean;
      isAdmin: boolean;
      memberType: Types.TeamMemberType;
    } | null;
    language: { __typename?: 'Language'; id: string; code: string };
    package: {
      __typename?: 'UserPackage';
      id: string;
      canonicalName: string;
      isAnnual?: boolean | null;
    };
    features: { __typename?: 'UserFeatureSet'; powerCasualEnabled: boolean };
  } | null;
};

export const ActionsQueryDocument = gql`
  query actionsQuery {
    user {
      id
      username
      team {
        id
        name
        ssoState
      }
      teamMembership {
        id
        isEnterprise
        isAdmin
        memberType
      }
      language {
        id
        code
      }
      package {
        id
        canonicalName
        isAnnual
      }
      features {
        powerCasualEnabled
      }
      permissions
    }
  }
`;

/**
 * __useActionsQueryQuery__
 *
 * To run a query within a React component, call `useActionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useActionsQueryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActionsQueryQuery,
    ActionsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActionsQueryQuery, ActionsQueryQueryVariables>(
    ActionsQueryDocument,
    options
  );
}
export function useActionsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActionsQueryQuery,
    ActionsQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActionsQueryQuery, ActionsQueryQueryVariables>(
    ActionsQueryDocument,
    options
  );
}
export type ActionsQueryQueryHookResult = ReturnType<
  typeof useActionsQueryQuery
>;
export type ActionsQueryLazyQueryHookResult = ReturnType<
  typeof useActionsQueryLazyQuery
>;
export type ActionsQueryQueryResult = Apollo.QueryResult<
  ActionsQueryQuery,
  ActionsQueryQueryVariables
>;
